import { COLLECTION_COMPONENT_TYPE, OPTIONAL_COMPONENT_TYPE } from "./editableComponentTypes";

export const ACTION_INSERT = 'insert';
export const ACTION_REMOVE = 'remove';
export const ACTION_INSERT_BEFORE = 'insertBefore';
export const ACTION_INSERT_AFTER = 'insertAfter';

const componentAction = (componentType, action) => `${componentType}::${action}`;

export const ACTION_COLLECTION_INSERT = componentAction(COLLECTION_COMPONENT_TYPE, ACTION_INSERT);
export const ACTION_COLLECTION_REMOVE = componentAction(COLLECTION_COMPONENT_TYPE, ACTION_REMOVE);
export const ACTION_COLLECTION_INSERT_BEFORE = componentAction(COLLECTION_COMPONENT_TYPE, ACTION_INSERT_BEFORE);
export const ACTION_COLLECTION_INSERT_AFTER = componentAction(COLLECTION_COMPONENT_TYPE, ACTION_INSERT_AFTER);

export const ACTION_OPTIONAL_INSERT = componentAction(OPTIONAL_COMPONENT_TYPE, ACTION_INSERT);
export const ACTION_OPTIONAL_REMOVE = componentAction(OPTIONAL_COMPONENT_TYPE, ACTION_REMOVE);